'use strict'
const CustomScroll = require('./dist/reactCustomScroll')

module.exports = CustomScroll